import { getExactTranslations } from "./translations_en_exact";

// This file contains longer strings or strings that require interpolation.
// For short strings, the file `translations_en_exact.js` is used.
const TRANSLATIONS_EN = {
  // Common
  'status-desc' : "Status",         // translates to "Estado" not "Etapa"
  'custom-f'    : "Personalized",

  // Auth
  'log-in-action'         : "Log In",
  'sign-up-action'        : "Sign Up",
  'have-account-login'    : "Already have an account? <1>Log in</1>",
  'create-free-account'   : "Don't have an account? <1>Create a free acount</1>",
  'password-too-short'    : "Your password should have a minimum of 6 characters",
  'verify-email-access'   : "Verify you can access <1>{{ email }}</1> so you do not lose access to your account",

  // Onboarding

  // Business
  'welcome-back'  : "Welcome back, {{name}}",
  'x-leads_one'   : "{{count, number}} lead",
  'x-leads_other' : "{{count, number}} leads",
  'active-f'      : "Active",
  'archived-f'    : "Archived",

  // Users
  'admin-role-desc'    : "Manages all aspects of the organization: billing, users and businesses",
  'business-role-desc' : "Manages selected businesses and their categories",
  'category-role-desc' : "Manages selected categories and their leads",
  'lead-role-desc'     : "Can only view, edit, and delete leads assigned to the user",

  // Business

  // Category
  'remaining-percentage' : "Remaining percentage: <1>{{ percentage }}%</1>",

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // Translations that are 1:1 in English (default Development language):
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  ...getExactTranslations(),
}

export default TRANSLATIONS_EN;
